// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-tabs {
  width: 100%;
  position: relative;
}

.section-tabs-bar {
  position: sticky;
  top: var(--header-height);
  z-index: 100;
  margin: 0 0 1.75rem;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
}

.section-tabs-nav {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.section-tabs-nav::-webkit-scrollbar {
  display: none;
}

.section-tab {
  position: relative;
  flex-shrink: 0;
  min-height: 46px;
  padding: 0.85rem 0.95rem 0.75rem;
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}

.section-tab:hover {
  color: var(--text-primary);
}

.section-tab.active {
  color: var(--text-primary);
}

.section-tab.active::before {
  content: '';
  position: absolute;
  inset-inline: 0.95rem;
  bottom: -1px;
  height: 2px;
  background: var(--accent-primary);
}

.section-tab.active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translateX(-50%);
  border-inline: 6px solid transparent;
  border-bottom: 7px solid var(--accent-primary);
}

.section-tabs-content {
  position: relative;
  max-width: 100%;
}

.content-section {
  margin-bottom: 3rem;
  scroll-margin-top: calc(var(--header-height) + 60px);
}

.content-section:last-child {
  margin-bottom: 0;
}

.section-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

/* ---------- Produktseite: große Leiste mit Icons ----------
 * Jeder Tab hat seine Themenfarbe (--tab-tone): Icon farbig, aktiver Tab farbig hinterlegt.
 * Läuft die Leiste über, zeigen Verläufe mit Pfeilen am Rand, dass es seitlich weitergeht. */
.section-tabs-prominent .section-tabs-bar {
  margin-bottom: 2.25rem;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
  box-shadow: 0 6px 18px -14px var(--shadow-primary);
}

.section-tabs-prominent .section-tab {
  --tab-tone: var(--tone-accent);
  flex: 1 0 auto;
  justify-content: center;
  min-height: 60px;
  padding: 0.7rem 1.35rem;
  border-right: 1px solid var(--border-primary);
  color: var(--text-secondary);
  font-family: var(--font-display);
  font-size: 1.12rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.section-tabs-prominent .section-tab:last-child {
  border-right: 0;
}

.section-tabs-prominent .section-tab:hover {
  background: color-mix(in srgb, var(--tab-tone) 9%, var(--bg-secondary));
  color: var(--text-primary);
}

.section-tabs-prominent .section-tab.active {
  background: color-mix(in srgb, var(--tab-tone) 18%, var(--bg-secondary));
  color: var(--text-primary);
}

.section-tabs-prominent .section-tab.active::before {
  inset-inline: 0;
  height: 3px;
  background: var(--tab-tone);
}

.section-tabs-prominent .section-tab.active::after {
  border-bottom-color: var(--tab-tone);
}

/* Hinweis auf seitliches Scrollen */
.section-tabs-bar {
  position: sticky;
}

.section-tabs-more {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 2.6rem;
  min-height: 0;
  padding: 0;
  border: 0;
  color: var(--accent-primary);
  font-family: var(--font-display);
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
}

.section-tabs-more.right {
  right: 0;
  justify-content: flex-end;
  padding-right: 0.35rem;
  background: linear-gradient(90deg, transparent, var(--bg-secondary) 55%);
}

.section-tabs-more.left {
  left: 0;
  justify-content: flex-start;
  padding-left: 0.35rem;
  background: linear-gradient(270deg, transparent, var(--bg-secondary) 55%);
}

.section-tabs-bar.more-right .section-tabs-nav {
  scroll-padding-right: 2.6rem;
}

@media (max-width: 680px) {
  .section-tabs-prominent .section-tab {
    flex: 0 0 auto;
    min-height: 52px;
    padding: 0.55rem 0.9rem;
    font-size: 1rem;
  }

  .section-tabs-prominent .section-tab .guide-icon {
    width: 20px;
    height: 20px;
  }
}

/* Handy: kein seitliches Scrollen – Tabs brechen in Zeilen um (Icon über Text) */
@media (max-width: 680px) {
  .section-tabs-prominent .section-tabs-nav {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(5.4rem, 1fr));
    overflow: visible;
  }

  .section-tabs-prominent .section-tabs-more {
    display: none;
  }

  .section-tabs-prominent .section-tab {
    flex-direction: column;
    justify-content: center;
    gap: 0.15rem;
    min-height: 54px;
    padding: 0.4rem 0.3rem;
    border-bottom: 1px solid var(--border-primary);
    font-size: 0.92rem;
    line-height: 1.1;
    white-space: normal;
    text-align: center;
  }

  .section-tabs-prominent .section-tab.active::after {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScrollSpyTabs/ScrollSpyTabs.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;6FAE6F;AAC7F;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;EAC3C,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uEAAuE;EACvE,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,UAAU;EACV,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,qBAAqB;EACrB,yEAAyE;AAC3E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iFAAiF;AACjF;EACE;IACE,aAAa;IACb,4DAA4D;IAC5D,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".section-tabs {\n  width: 100%;\n  position: relative;\n}\n\n.section-tabs-bar {\n  position: sticky;\n  top: var(--header-height);\n  z-index: 100;\n  margin: 0 0 1.75rem;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.section-tabs-nav {\n  display: flex;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.section-tabs-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.section-tab {\n  position: relative;\n  flex-shrink: 0;\n  min-height: 46px;\n  padding: 0.85rem 0.95rem 0.75rem;\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.section-tab:hover {\n  color: var(--text-primary);\n}\n\n.section-tab.active {\n  color: var(--text-primary);\n}\n\n.section-tab.active::before {\n  content: '';\n  position: absolute;\n  inset-inline: 0.95rem;\n  bottom: -1px;\n  height: 2px;\n  background: var(--accent-primary);\n}\n\n.section-tab.active::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: -1px;\n  transform: translateX(-50%);\n  border-inline: 6px solid transparent;\n  border-bottom: 7px solid var(--accent-primary);\n}\n\n.section-tabs-content {\n  position: relative;\n  max-width: 100%;\n}\n\n.content-section {\n  margin-bottom: 3rem;\n  scroll-margin-top: calc(var(--header-height) + 60px);\n}\n\n.content-section:last-child {\n  margin-bottom: 0;\n}\n\n.section-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* ---------- Produktseite: große Leiste mit Icons ----------\n * Jeder Tab hat seine Themenfarbe (--tab-tone): Icon farbig, aktiver Tab farbig hinterlegt.\n * Läuft die Leiste über, zeigen Verläufe mit Pfeilen am Rand, dass es seitlich weitergeht. */\n.section-tabs-prominent .section-tabs-bar {\n  margin-bottom: 2.25rem;\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border-primary);\n  border-bottom: 1px solid var(--border-primary);\n  box-shadow: 0 6px 18px -14px var(--shadow-primary);\n}\n\n.section-tabs-prominent .section-tab {\n  --tab-tone: var(--tone-accent);\n  flex: 1 0 auto;\n  justify-content: center;\n  min-height: 60px;\n  padding: 0.7rem 1.35rem;\n  border-right: 1px solid var(--border-primary);\n  color: var(--text-secondary);\n  font-family: var(--font-display);\n  font-size: 1.12rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.section-tabs-prominent .section-tab:last-child {\n  border-right: 0;\n}\n\n.section-tabs-prominent .section-tab:hover {\n  background: color-mix(in srgb, var(--tab-tone) 9%, var(--bg-secondary));\n  color: var(--text-primary);\n}\n\n.section-tabs-prominent .section-tab.active {\n  background: color-mix(in srgb, var(--tab-tone) 18%, var(--bg-secondary));\n  color: var(--text-primary);\n}\n\n.section-tabs-prominent .section-tab.active::before {\n  inset-inline: 0;\n  height: 3px;\n  background: var(--tab-tone);\n}\n\n.section-tabs-prominent .section-tab.active::after {\n  border-bottom-color: var(--tab-tone);\n}\n\n/* Hinweis auf seitliches Scrollen */\n.section-tabs-bar {\n  position: sticky;\n}\n\n.section-tabs-more {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  width: 2.6rem;\n  min-height: 0;\n  padding: 0;\n  border: 0;\n  color: var(--accent-primary);\n  font-family: var(--font-display);\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.section-tabs-more.right {\n  right: 0;\n  justify-content: flex-end;\n  padding-right: 0.35rem;\n  background: linear-gradient(90deg, transparent, var(--bg-secondary) 55%);\n}\n\n.section-tabs-more.left {\n  left: 0;\n  justify-content: flex-start;\n  padding-left: 0.35rem;\n  background: linear-gradient(270deg, transparent, var(--bg-secondary) 55%);\n}\n\n.section-tabs-bar.more-right .section-tabs-nav {\n  scroll-padding-right: 2.6rem;\n}\n\n@media (max-width: 680px) {\n  .section-tabs-prominent .section-tab {\n    flex: 0 0 auto;\n    min-height: 52px;\n    padding: 0.55rem 0.9rem;\n    font-size: 1rem;\n  }\n\n  .section-tabs-prominent .section-tab .guide-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* Handy: kein seitliches Scrollen – Tabs brechen in Zeilen um (Icon über Text) */\n@media (max-width: 680px) {\n  .section-tabs-prominent .section-tabs-nav {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(5.4rem, 1fr));\n    overflow: visible;\n  }\n\n  .section-tabs-prominent .section-tabs-more {\n    display: none;\n  }\n\n  .section-tabs-prominent .section-tab {\n    flex-direction: column;\n    justify-content: center;\n    gap: 0.15rem;\n    min-height: 54px;\n    padding: 0.4rem 0.3rem;\n    border-bottom: 1px solid var(--border-primary);\n    font-size: 0.92rem;\n    line-height: 1.1;\n    white-space: normal;\n    text-align: center;\n  }\n\n  .section-tabs-prominent .section-tab.active::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
